module.exports = __webpack_public_path__ + "static/media/happy-customer.e1f04460.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/happy-customer.png
// module id = 289
// module chunks = 0